import { HeartPulse24Filled, HeartPulse24Regular } from "@fluentui/react-icons";
import React from "react";
import { TeamAppConfig } from "Apps/TeamAppModel";

export const M365HealthApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "m365hlth" */ "./HealthApp");
    return { default: namedExport.HealthApp };
});

export const M365Health: TeamAppConfig = {
    title: "Signal Health",
    regularIcon: HeartPulse24Regular,
    filledIcon: HeartPulse24Filled,
    description: "Signal Health app surfaces the real-time signal health to Service Owners, Incident Managers, OCEs and leadership team.",
    team: "OSP",
    publicId: "Exchange\\OSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    path: "/M365Health",
    tags: ["xam", "errors", "summary", "availability", "dag", "trend", "network", "cafe", "cafe heatmap"],
    app: M365HealthApp
};
